<section class="container">
  @if (!completed$?.value) {
    <h1 class="title">
      @for (item of seedingPending; track item) {
        <span>{{ item }}</span>
      }
    </h1>
  }
  @if (completed$?.value) {
    <h1 class="title">
      @for (item of seedingComplete; track item) {
        <span>{{ item }}</span>
      }
    </h1>
  }
</section>
